<template>
  <div class="kye-header noselect">
    <div class="panel" @click.stop="openOperationInterface">
      <i class="logo layout layout-logo"></i>
      <h2>{{title}}</h2>
    </div>
    <div class="panel panel_r">
      <vms-vehicle-count />
      <BssTestPlatform v-if="isUat || isSit"></BssTestPlatform>
      <div class="hot-pointer check-rule-tool" @click="hotPoint" v-if="checkRulePermission" data-clk-logkey="check_rule_hot_map_enter">
        <i class="layout layout-relitu"></i>
        <span>热力图</span>
      </div>
      <div class="check-rule-tool" @click="checkRule" v-if="checkRulePermission">
        <i class="layout layout-a-yemianjiance1x"></i>
        <span>页面检测</span>
      </div>
      <a class="flex-tool"
         href="#/ams/apps-board">
        <!-- <img :src="productSvg"> -->
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>产品合集</title>
          <g id="产品合集" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="编组-15备份">
                  <rect id="矩形复制-4" x="0" y="0" width="24" height="24"></rect>
                  <g id="编组-8" transform="translate(2.000000, 2.000000)" stroke="#FFFFFF">
                      <rect id="Rectangle" x="1.125" y="1.125" width="7" height="7"></rect>
                      <rect id="Rectangle备份-2" x="1.125" y="12.125" width="7" height="7"></rect>
                      <rect id="Rectangle备份-3" x="12.125" y="12.125" width="7" height="7" rx="3.5"></rect>
                      <rect id="Rectangle备份" x="12.125" y="1.125" width="7" height="7"></rect>
                  </g>
              </g>
          </g>
        </svg>
        <!-- <i class="layout layout-custom1"></i> -->
        <span>产品合集</span>
      </a>
      <AuthApply></AuthApply>
      <el-popover placement="bottom"
                  trigger="hover"
                  :open-delay="400"
                  v-show="lookUpOptionsLoaded"
                  popper-class="header-tool-popover"
                  width="292">
        <ul class="header-tool-wrap" id="kye_tool_auth_apply">
          <li v-for="opt in tools"
              :key="opt.title"
              class="item"
              @click="showHelper(opt)">
            <i :class="`layout layout-${opt.icon}`"></i>
            <p>{{opt.title}}</p>
          </li>
        </ul>
        <div slot="reference"
             class="flex-tool">
          <i class="layout layout-a-gongju1x"></i>
          <span>工具</span>
        </div>
      </el-popover>
      <div id="kts-gd-plugin-wrapper"
           style="padding:0;"></div>
      <div class="flex-tool kts-gd-plugin-tool"
           @click="openKtsPlugin">
        <i class="layout layout-a-gongdan1x"></i>
        <span>工单</span>
        <span class="kts-gd-plugin-tool_dot"
              :style="gdDotStyle"
              v-show="showGdDot && gdCount">{{gdCount}}</span>
      </div>
      <crmwasAnswer v-if="user.name" />
      <OfficeNetBoard v-if="user.name" />
      <div class="flex-tool"
           :title="tips"
           @click="showScreenFullTips">
        <i class="layout layout-a-quanping1x"></i>
        <span>全屏</span>
      </div>
      <el-dropdown trigger="click"
                   @command="handleCommand">
        <div class="info-wrap">
          <div class="user-avatar">
            <img v-show="!!avatar"
                 :src="avatar">
            <i v-show="!avatar"
               class="layout layout-user"></i>
          </div>
          <div class="info">
            <p>{{user.name}}</p>
            <label>{{user.department || user.duty}}</label>
          </div>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="switchAuth"
                            v-if="!isProd && !isUat && !isSit">
            <i class="header-user-dropitem layout layout-quanxianshenqing" />&ensp;鉴权
            <el-switch :width="35"
                       :value="auth"
                       active-color="#6d2ef8"
                       inactive-color="#d2d2d6">
            </el-switch>
          </el-dropdown-item>
          <el-dropdown-item command="switchGray" v-if="isGrayUser">
            <i class="header-user-dropitem layout layout-user" />&ensp;灰度
            <el-switch :width="35"
                       :value="grayFlag"
                       active-color="#6d2ef8"
                       inactive-color="#d2d2d6">
            </el-switch>
          </el-dropdown-item>
          <el-dropdown-item command="setTheme">
            <i class="header-user-dropitem layout layout-diaoseban" />&ensp;主题设置
          </el-dropdown-item>
          <el-dropdown-item command="clearCache">
            <i class="header-user-dropitem layout layout-clear" />&ensp;清除缓存
          </el-dropdown-item>
          <el-dropdown-item command="otherAccount" v-if="checkAuth('BToOe0ySNoBx')">
            <i class="header-user-dropitem layout layout-switch-account" />&ensp;其他账号
          </el-dropdown-item>
          <el-dropdown-item command="editPassword">
            <i class="header-user-dropitem layout layout-pen" />&ensp;修改密码
          </el-dropdown-item>
          <el-dropdown-item command="logout">
            <i class="header-user-dropitem layout layout-logout" />&ensp;退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <kye-dialog class="kye-header-tools-helper-dialog"
                :title="toolsDailogOptions.title"
                :width="toolsDailogOptions.width"
                :modal="toolsDailogOptions.modal"
                :visible.sync="toolsDailogOptions.visible"
                append-to-body
                :view.sync="toolsDailogOptions.view"
                :before-close="closeToolsHelper">
      <component :is="toolsDailogOptions.view"
                 @close="closeToolsHelper"
                 :helper="toolsDailogOptions.helper"
                 :url="toolsDailogOptions.url"
                 :upgradeLogList="upgradeLogList">
      </component>
    </kye-dialog>
    <kye-dialog :title="dialogOptions.title"
                :width="dialogOptions.width"
                :visible.sync="dialogOptions.visible"
                append-to-body
                :view.sync="dialogOptions.view"
                :before-close="closeHelper">
      <component :is="dialogOptions.view"
                 @close="closeHelper"
                 :helper="dialogOptions.helper"
                 :url="dialogOptions.url"
                 :upgradeLogList="upgradeLogList">
      </component>
    </kye-dialog>
    <module-upgrade-log />
    <safe-tips />
    <Scheduling />
    <QuestionnaireTips />
    <theme ref="theme" />
    <operation-interface ref="operationInterface" />
    <DbcDrawer v-if="!isProd" append-to-body ref="dbcDrawer" />
    <MultiModulePanel :multiVersionName="multiVersionName" :multiInfoId="multiInfoId" />
  </div>
</template>

<script>
  import localforage from 'localforage'
  // import { createWatermarkStyle } from 'public/utils'
  import { TITLE } from './conf'
  import { tools } from '@/shared/home-modules/helpers/form'
  import VmsVehicleCount from '@/shared/home-modules/header/vms-vehicle-count'
  import CommentWrapper from '../components/comment'
  import ModuleUpgradeLog from '../components/module-upgrade-log'
  import SafeTips from '../components/safe-tips'
  import Scheduling from '../components/scheduling'
  // import QuestionnaireTips from '../components/questionnaire-tips'
  import AccountList from '../components/account-list-dialog'
  import Theme from '../components/theme'
  import OperationInterface from '../components/operation-interface'
  // import HrVideoTutorial from '../components/hr-video-tutorial'
  import MultiModulePanel from '../components/multi-module-panel.vue'
  import { ENV } from 'public/config'
  import { getMultiModuleData } from '@/layout/utils'
  import { getSubModuleName, getMatchedModule } from '@/layout/router/remote/index.js'
  import OfficeNetBoard from '../components/office-net-board.vue'
  export default {
    name: 'header-top',
    components: {
      MultiModulePanel,
      Helper: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/index'),
      GPSLocation: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/GPSLocation'),
      CarSwingCard: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/car-swing-card'),
      Calendar: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/calendar'),
      Log: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/log'),
      Sms: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/sms'),
      Distance: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/distance'),
      // Comment: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/comment'),
      MapAuth: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/mapAuth'),
      VirtualNumber: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/virtual-number'),
      OperationInterface,
      VmsVehicleCount,
      CommentWrapper,
      ModuleUpgradeLog,
      SafeTips,
      Theme,
      QuestionnaireTips: window.__ERP_REMOTE_IMPORT__('qms/QmsQuestionnaireGlobalModal'),
      Scheduling,
      AccountList,
      crmwasAnswer: window.__ERP_REMOTE_IMPORT__('crm_was/crmwasAnswer'), // 咨询解答
      AuthApply: window.__ERP_REMOTE_IMPORT__('sys/HomeAuthApply'), // 权限申请
      BssTestPlatform: window.__ERP_REMOTE_IMPORT__('sys/BssTestPlatform'), // 测试平台
      DbcDrawer: window.__ERP_REMOTE_IMPORT__('dbc/dbcDrawer'), // OEM抽屉组件
      OfficeNetBoard
      // HrVideoTutorial
    },
    data () {
      return {
        search: '',
        tools: tools.filter(v => typeof v.show === 'function' ? v.show() : true).filter(v => v.helper !== 'addressSearch'),
        dialogOptions: this.genDialogOptions(),
        toolsDailogOptions: this.genDialogOptions(),
        checkRuleInstall: null,
        showGdDot: false,
        gdDotColor: 'red',
        upgradeLogList: [],
        // svgFilter: +localStorage.svgFilter || 1,
        title: this.getSystemName(),
        tips: '按 F11 进入/退出 全屏模式',
        isGrayUser: sessionStorage.getItem('GLOBAL_USER_GRAY'),
        grayFlag: document.cookie.includes('gray=1'),
        isProd: ENV === 'prd',
        isUat: ENV === 'uat',
        isSit: ENV === 'sit',
        checkRulePermission: false, // 页面检测入口权限
        authStatus: 1, // 是否开启鉴权
        gdCount: 0, // 工单未读数
        multiVersionName: '', // 泳道环境-版本名称
        multiInfoId: '' // 泳道环境-版本id
      }
    },
    created () {
      this.$bus.$on('SET_THEME', this.themeChange)
      this.$bus.$on('KTS_RED_DOT', this.ktsPluginDotChange)
      this.$bus.$on('SET_SYSTEM_NAME', this.setSystemName)
      // this.$bus.$on('HELPER_COMMET', this.showComment)
      // this.$bus.$on('HELPER_VIDEO', this.showVideo)
    },
    beforeUpdate () {
      // 避免多个状态同时更新
      setTimeout(() => {
        this.checkUserGray()
      }, 1000)
    },
    mounted () {
      this.clickNum = 0
      this.$bus.$once('APP_LOADED', this.onAppLoaded)
      // this.svgFilterChange(this.svgFilter)
    },
    beforeDestroy () {
      this.$bus.$off('SET_THEME', this.themeChange)
      this.$bus.$off('KTS_RED_DOT', this.ktsPluginDotChange)
      this.$bus.$off('SET_SYSTEM_NAME', this.setSystemName)
      this.$bus.$off('SET_GARY', this.grayChange)
    },
    computed: {
      auth () {
        return !!this.authStatus
      },
      user () {
        return this.$store.state.user
      },
      avatar () {
        return this.$store.state.avatar
      },
      gdDotStyle () {
        return { backgroundColor: this.gdDotColor }
      },
      lookUpOptionsLoaded () {
        return Object.keys(this.$store.state.lookUpOptions).length
      },
    },
    methods: {
      hotPoint () {
        window.__callWebMonitorPanel()
      },
      onAppLoaded () {
        this.getAuthStatus()
        this.getCheckRulePermission()
      },
      // 获取页面检测规范插件的权限
      getCheckRulePermission() {
        let permission = this.$store.state.permission.menus
        this.checkRulePermission = permission && permission.includes('BToQGEG4JmEO')
      },
      // 打开页面检测规范
      async checkRule() {
        if (this.checkRuleInstall) {
          this.checkRuleInstall.open()
          return
        }
        import(/* webpackChunkName: "public-check-rule" */ `@/shared/home-modules/helpers/check-rules/index.vue`).then(res => {
          const Ctor = this.$options._base.extend(res.default)
          this.checkRuleInstall = new Ctor()
          this.checkRuleInstall.$root._routerRoot = this
          this.checkRuleInstall.$mount('#kts-gd-plugin-wrapper')
        })
      },
      themeChange (obj, type) {
        if (!this.rootEl) {
          this.rootEl = this.$el
        }
        if (!this.avatarEl) {
          this.avatarEl = this.rootEl.querySelector('.user-avatar i')
        }
        if (!type || type === 'header') {
          if (!this.avatar) {
            this.avatarEl.style.color = obj.headerGradient
          }
          this.rootEl.style.background = `linear-gradient(90deg, ${obj.header}, ${obj.headerGradient})`
        }
      },
      // 获取系统名称
      getSystemName() {
        let title = TITLE
        if (ENV && ENV !== 'prd') {
          title = `${ENV.toUpperCase()}-${title}`
        }
        const name = localStorage.GLOABL_ERP_SYSTEM_NAME
        return name || title + (window.location.pathname === '/' ? '' : ` - ${window.location.pathname.slice(1, -1)}`)
      },
      // 修改系统名称
      setSystemName () {
        let title = this.getSystemName()
        if (this.isGrayModulebyRoute()) {
          title += '（灰度）'
          this.title = title
          return
        }
        this.title = title
        this.setMultiName()
      },
      // 设置多版本文案
      setMultiName () {
        const name = this.getMultiModuleByRoute()
        if (name) {
          this.multiVersionName = name
        }
      },
      // 2022-12-21 判断当前菜单模块是否是灰度模块
      isGrayModulebyRoute () {
        const moduleName = getSubModuleName(this.$route)
        const moduleMeta = getMatchedModule(moduleName)
        let grayModules = sessionStorage.ERPGRAYMODULE
        grayModules = grayModules ? grayModules.split(',') : []
        return moduleMeta ? grayModules.includes(moduleMeta.name) : false
      },
      // 2023-02-11 判断非生产环境是否是多版本
      getMultiModuleByRoute () {
        try {
          // if (this.isProd) {
          //   return ''
          // }
          const multiSessionData = getMultiModuleData()
          if (multiSessionData) {
            this.multiInfoId = multiSessionData.envId
            return `(${multiSessionData.systemName}/${multiSessionData.envName})`
          }
          return ''
        } catch (err) {
          console.error('getMultiModuleByRoute:', err)
          return ''
        }
      },
      setTheme () {
        this.$refs.theme.visible = true
      },
      logout () {
        this.$store.dispatch('logout')
      },
      getAuthStatus () {
        this.$http('auth.resource.userValidate', {}, false).then(status => {
          this.authStatus = status
          localStorage.setItem('GLOBAL_AUTH_STATUS', status)
        })
      },
      switchAuth () {
        let newStatus = this.authStatus === 0 ? 1 : 0
        this.$http('auth.resource.userValidate', { needValidate: newStatus }, false).then(status => {
          this.authStatus = status
          localStorage.setItem('GLOBAL_AUTH_STATUS', status)
          this.$message.success(`鉴权已${newStatus === 0 ? '关闭' : '开启'}，退出系统重新登录后生效`)
        }).catch(_ => {
          this.$message.error('鉴权切换失败，请检查auth.resource.userValidate接口是否正常')
        })
      },
      switchGray () {
        sessionStorage.setItem('GLOBAL_USER_GRAY_FLAG', this.grayFlag ? 0 : 1)
        this.$message.warning(`正在${this.grayFlag ? '退出' : '进入'}灰度，请稍后操作`)
        setTimeout(() => {
          window.__intercept__ = 0
          location.reload()
        }, 300)
      },
      checkUserGray () {
        if (sessionStorage.getItem('GLOBAL_USER_GRAY') !== '1') {
          this.isGrayUser = false
        }
      },
      clearCache () {
        localforage.createInstance({ name: 'api' }).clear()
        if (ENV !== 'prd') {
          // 通用查询分组
          localStorage.removeItem('GLOBAL_SEARCH_GENERIC_GROUP')
          // 通用查询
          localStorage.removeItem('GLOBAL_SEARCH_GENERIC')
          // 表格拖拽列宽度
          localStorage.removeItem('GLOBAL_COL_WIDTH')
          // 表格拖拽前配置列宽度
          localStorage.removeItem('GLOBAL_COL_HISTORY_WIDTH')
          // 表格固定列
          localStorage.removeItem('GLOBAL_FIXED_COL')
        }
        this.$http('auth.resource.refreshUserPermissionCache', {}, false)
        this.$message.success('缓存已清除')
        // 清除缓存后需要刷新页面
        location.reload()
      },
      otherAccount() {
        this.showDynamicDialog('AccountList', '借用账号', '1125px')
      },
      editPassword () {
        this.$router.push('/uamp/edit-password')
      },
      /**
       * 权限判断
       */
      checkAuth(auth) {
        let menus = this.$store.state.permission.menus
        return menus.includes(auth)
      },
      // 通用弹窗
      showDynamicDialog(view, title, width = '1200px') {
        this.dialogOptions.visible = true
        this.dialogOptions.view = view
        this.dialogOptions.title = title
        this.dialogOptions.width = width
      },
      handleCommand (val) {
        this[val]()
      },
      genDialogOptions () {
        return { title: '', visible: false, view: '', width: null, helper: '', url: '', modal: true }
      },
      showHelper (opt) {
        if (opt.func) {
          return opt.func(this)
        }
        if (this.toolsDailogOptions.visible) {
          this.closeToolsHelper()
        }
        this.$nextTick(() => {
          this.toolsDailogOptions.title = opt.title
          this.toolsDailogOptions.width = opt.width || 6
          this.toolsDailogOptions.helper = opt.helper
          this.toolsDailogOptions.url = opt.url
          this.toolsDailogOptions.view = opt.view || 'Helper'
          this.toolsDailogOptions.modal = false
          this.toolsDailogOptions.visible = true
        })
      },
      closeHelper () {
        this.dialogOptions = this.genDialogOptions()
      },
      closeToolsHelper () {
        this.toolsDailogOptions = this.genDialogOptions()
      },
      // showComment () {
        // this.showHelper({
        //   title: '使用评价',
        //   width: 3.5,
        //   helper: null,
        //   url: null,
        //   view: 'Comment',
        // })
      // },
      showScreenFullTips () {
        this.$message(this.tips)
      },
      openKtsPlugin (e) {
        if (this.ktsGdPlugin) {
          this.ktsGdPlugin.open()
          return
        }
        // 判断是否正在初始化，避免重复点击
        if (this.isKtsInitializing) {
          return
        }
        this.isKtsInitializing = true
        let ktsModule = null
        const ktsEntry = 'kts'
        if (!ENV) {
          ktsModule = import(/* webpackChunkName: "kts-gd-plugin" */ `@/${ktsEntry}/components/kts-work-plugin/index.vue`)
        } else {
          ktsModule = new Promise(window.__ERP_REMOTE_IMPORT__('kts/ktsGdPlugin'))
        }
        ktsModule.then(res => {
            let Ctor = this.$options._base.extend(res.default)
            this.ktsGdPlugin = new Ctor({ parent: this })
            this.ktsGdPlugin.$mount('#kts-gd-plugin-wrapper')
            if (e && e.clientX && e.clientY) {
              this.ktsGdPlugin.$nextTick(_ => {
                this.ktsGdPlugin.open()
                this.isKtsInitializing = false
              })
            }
          })
          .catch(console.log)
      },
      ktsPluginDotChange (data) {
        this.showGdDot = data && data.isShow
        this.gdDotColor = (data && data.color) || 'red'
        this.gdCount = data && data.count
      },
      openOperationInterface () {
        this.clickNum += 1
        if (this.clickNum >= 5) {
          this.clickNum = 0
          this.$refs.operationInterface.show = true
        }
      }
      // showVideo () {
      //   this.showHelper({
      //     title: '视频教程',
      //     width: 4.2,
      //     helper: null,
      //     url: null,
      //     view: 'HrVideoTutorial',
      //   })
      // },
    }
  }
</script>

<style lang="scss">
  .kye-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: linear-gradient(90deg, #894fd5, #4d26bf);
    background: #6D2EF8;
    color: #ffffff;
    padding: 0 20px;

    .el-input {
      .el-input__inner {
        border-radius: 20px;
        background-color: transparent;
        border-color: #aaa;
        color: #ffffff;
      }
    }

    .panel {
      display: flex;
      align-items: center;
      i.layout {
        width: 18px;
        &.layout-kuasheng1 {
          font-size: 18px;
        }
      }
      i.logo {
        width: 24px;
        height: 24px;
        font-size: 24px;
        margin-right: 8px;
      }
      svg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      a:hover svg rect {
        stroke-width: 2px;
      }
      .check-rule-tool {
        display: flex;
        align-items: center;
        cursor: pointer;
        .layout-check-rule-icon {
          width: 18px;
          font-size: 17px;
        }
      }
    }
    .panel_r {
      height: 100%;
    }
    .panel_r > *:not(.el-dropdown):not(.gd-plugin-wrapper) {
      height: 100%;
      padding: 16px 12px;
      &:hover {
        font-weight: bold;
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .panel_r > span .layout {
      height: 15px;
    }
    .flex-tool {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .info-wrap {
      display: flex;
      align-items: center;
      cursor: pointer;
      .user-avatar {
        margin-left: 16px;
        margin-right: 6px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        background-color: #ffffff;
        i {
          font-size: 24px;
          color: #4d26bf;
        }
        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
      .el-icon-caret-bottom {
        padding-left: 8px;
        color: #ffffff;
      }
      .info {
        color: #ffffff;
        p {
          font-weight: bold;
          font-size: 14px;
          line-height: 14px;
        }
      }
    }
    .kts-gd-plugin-tool {
      position: relative;
      &_dot {
        position: absolute;
        top: 4px;
        right: 50%;
        transform: translateX(50%);
        height: 14px;
        line-height: 14px;
        padding: 0 4px;
        text-align: center;
        color: #ffffff;
        background-color: #ff5351;
        border-radius: 10px;
        font-size: 12px;
      }
    }
  }

  .header-user-dropitem {
    font-size: 14px !important;
    width: 14px;
    height: 14px;
  }

  .kye-header-tools-helper-dialog {
      pointer-events: none;
      > .el-dialog {
        pointer-events: auto;
      }
  }
  .kye-header-multi-popover {
    text-align: left;
    padding: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout/header.vue